<div class="site-grid-layout" [class.no-sidebar]="!showSidebar()">

   <!-- HEADER -->
   <app-site-header class="site-header"></app-site-header>

   <!-- SIDEBAR / MOBILE TOP NAV -->
   @if(showSidebar()) {
   <app-site-sidebar class="site-sidebar"></app-site-sidebar>
   }

   <!-- MAIN CONTENT -->
   <main class="site-main overflow-auto p-4">
      <div class="container-fluid">
         <section>
            <router-outlet></router-outlet>
         </section>
      </div>
   </main>

   <!-- FOOTER -->
   <app-site-footer class="site-footer"></app-site-footer>

</div>

